import { createContext, useContext } from 'react';

/** Shell state pages may need: whether the desktop sidebar is collapsed to icons. */
export const ShellContext = createContext<{ collapsed: boolean }>({ collapsed: false });
export const useShell = () => useContext(ShellContext);
